import { createRouter, createWebHistory } from 'vue-router'
import Users from '../views/Admin/Users/index.vue'
import Main from "@/views/App/MainPage/Main.vue";
import DefaultAdmin from "@/views/Admin/Default/index.vue";
import NewProduct from "@/views/Admin/NewItem/products.vue";
import ProductItem from "@/views/App/ProductItem/ProductItem.vue";
import Checkout from "@/views/App/Checkout/Checkout.vue";
import Account from "@/views/App/Account/Account.vue";
import Products from "@/views/App/Products/Products.vue";
import Auth from "@/views/App/Auth/Auth.vue";
import OrderConfirmed from "@/views/App/OrderConfirmed/OrderConfirmed.vue";
import OrderItem from "@/views/App/OrderItem/OrderItem.vue";
import AdminOrderItem from "@/views/Admin/OrderItem/OrderItem.vue";
import pageItem from "@/views/App/PageItem/PageItem.vue";
import NotFound from "@/views/App/NotFound/NotFound.vue";
import MainPage from "@/views/Admin/MainPage/MainPage.vue"
import GiftCard from "@/views/App/GiftCard/GiftCard.vue"
import axios from "axios";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', component: Main, name: "Main"},
        { path: '/products', component: Products, name: "products"},
        { path: '/products/:code', component: ProductItem, name: "product-item"},

        { path: '/pages/:url', component: pageItem, name: "page-item"},
        { path: '/card', component: GiftCard, name: "gift-card"},

        { path: '/checkout', component: Checkout, name: "checkout"},
        { path: '/profile', redirect: '/profile/orders'},
        { path: '/profile/orders', component: Account, name: "orders"},
        { path: '/profile/settings', component: Account, name: "settings",
            meta: { title: 'Account Settings' },
        },

        { path: '/order/:number', component: OrderItem, name: "order-item"},

        { path: '/orderSuccess', component: OrderConfirmed, name: "OrderSuccess"},
        // { path: '/orderFail', component: OrderConfirmed, name: "OrderFail"},

        { path: '/auth/:type(login|register)', component: Auth, name: "auth"},
        { path: '/auth', redirect: '/auth/login'},
        { path: '/auth/:type', redirect: '/auth/login'},

        { path: '/user', component: Users},
        { path: '/admin/main', component: MainPage, name: "adm-main"},
        { path: '/admin/pages', component: DefaultAdmin, name: "adm-pages"},
        { path: '/admin/products', component: DefaultAdmin, name: "adm-products"},
        { path: '/admin/orders', component: DefaultAdmin, name: "adm-orders"},
        { path: '/admin/users', component: DefaultAdmin, name: "adm-users"},

        { path: '/admin/products/add-new', component: NewProduct, name: "adm-add-product"},
        { path: '/admin/users/add-new', component: NewProduct, name: "adm-add-user"},
        { path: '/admin/pages/add-new', component: NewProduct, name: "adm-add-page"},

        {
            path: '/admin/products/:code',
            component: NewProduct,
            name: "adm-product-item",
        },

        {
            path: '/admin/orders/:number',
            component: AdminOrderItem,
            name: "adm-order-item",
        },


        {
            path: '/:pathMatch(.*)*', // 404
            name: 'not-found',
            component: NotFound,
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        document.getElementById('app').scrollIntoView({
            behavior: 'smooth'
        });
    }
})

router.beforeEach(async (to, from, next) => {
    if (to.path.startsWith('/admin')) {
        let hasAccess = await checkUserPermissions();
        if (!hasAccess) {
            next("/"); // перенаправление на главную страницу
        } else {
            next(); // продолжаем переход
        }
    } else {
        next();
    }
});

let checkUserPermissions = async () => {
    try {
        const baseUrl = process.env.VUE_APP_API_URL + "";
        const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };
        const response = await axios.get(
            `${baseUrl}/users/permission`,
            {
                params: {},
                ...config
            }
        );

        return response.data.message === 'Permission Accepted';
    } catch (error) {
        return false;
    }
}

export default router
